import { RecommendationsService } from '@repo/go-widgets';

import { notificationsServiceAgent } from 'src/api/notifications-service-agent';
import { requireService } from 'src/packages/di';

export class RecommendationsStore {
  readonly recommendationsService: RecommendationsService;

  constructor() {
    const userData = requireService('authService').userInfo;
    this.recommendationsService = new RecommendationsService(
      notificationsServiceAgent,
      userData,
      requireService('directories'),
    );
  }

  init() {
    return this.recommendationsService.init();
  }
}
